import React from "react";
import { components } from "react-select";
import { Icon, ICON_SIZES } from "#library/components/Icon/Icon";
import cross from "#library/assets/icons/jds_cross.svg";
export var ClearIndicator = function ClearIndicator(props) {
  return /*#__PURE__*/React.createElement(components.ClearIndicator, props, /*#__PURE__*/React.createElement(Icon, {
    xlinkHref: "#".concat(cross.id),
    size: ICON_SIZES.MEDIUM
  }));
};